module.exports = __webpack_public_path__ + "static/media/19068_1317078413760_5871412_n.2526b780.jpg";